import { render, staticRenderFns } from "./CustomerDetailAddress.vue?vue&type=template&id=b987afe4"
import script from "./CustomerDetailAddress.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports